//! must be as compatible with older browsers as possible!
(() => {
  if (document.body.getAttribute('class').indexOf('neos-login-form') == -1) {
    return;
  }

  if (
    (document.all && !document.querySelector) || // ie <7
    (document.all && window.XMLHttpRequest) || // ie 7-10
    (document.body.style.msTouchAction !== undefined) || // ie 10+
    (Object.prototype.toString.call(window.operamini) === '[object OperaMini]') // opera mini
  ) {
    document.getElementsByTagName('html')[0].setAttribute('class', 
      (document.getElementsByTagName('html')[0].getAttribute('class') || '') + ' incompatible'
    );
  }
  
  let elements = document.getElementsByClassName('compatibility-warning');
  for (let i = 0; i < elements.length; i++) {
    var element = elements[i];
    var close = element.children[element.children.length-1];

    close.addEventListener('click', function (event) {
      element.setAttribute('style', 'display:none;');
    });
  }
})();